/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EquipementRegistreDto } from '../../models/equipement-registre-dto';

export interface GetEquipementRegistres$Params {
  /**
   * Id equipement pour lequel il faut récupérer les équipements registres.
   */
  idEquipement: string;
}

export function getEquipementRegistres(
  http: HttpClient,
  rootUrl: string,
  params: GetEquipementRegistres$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<EquipementRegistreDto>>> {
  const rb = new RequestBuilder(rootUrl, getEquipementRegistres.PATH, 'get');
  if (params) {
    rb.path('idEquipement', params.idEquipement, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EquipementRegistreDto>>;
    })
  );
}

getEquipementRegistres.PATH = '/v1/equipements/{idEquipement}/equipement_registres';
